let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8yyqm")).then(() => parcelRequire('jhQzd'));